import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Localize, Translate } from "react-redux-i18n";
import { Button, Dropdown } from "react-bootstrap";
import TableAction from "../containers/TableAction";
import { KCheck } from "../../KCheck";
import ld from "lodash";
import { def } from "../../commons";
import { ColumnType } from "../../kptable";
import { tooltipate } from "../../../index";
function renderCell(id, child, childIndex, datum, keyField, confirmation, waiting, onHandleAction, onCancelAction) {
    const { colid, type, render, classes, actions = [], collapsed = false } = child.props;
    const classNames = classes || "";
    if (type !== ColumnType.ACTIONS) {
        if (type === ColumnType.DATE) {
            return (_jsx("td", { className: classNames, children: datum[colid] ? _jsx(Localize, { value: datum[colid], dateFormat: "kptable.date.short" }) : null }, childIndex));
        }
        else if (type === ColumnType.DATETIME) {
            return (_jsx("td", { className: classNames, children: datum[colid] ? _jsx(Localize, { value: datum[colid], dateFormat: "kptable.date.long" }) : null }, childIndex));
        }
        else {
            if (render) {
                return (_jsx("td", { className: classNames, children: render(datum) }, childIndex));
            }
            else {
                return (_jsx("td", { className: classNames, children: datum[colid] !== undefined && datum[colid] !== null ? datum[colid].toString() : "" }, childIndex));
            }
        }
    }
    else {
        if (waiting[datum[keyField]]) {
            return (_jsx("td", { style: { textAlign: "right" }, children: _jsx("div", { className: "kpactions", children: _jsx("i", { className: "fa fa-spinner-third fa-spin spinner" }) }) }, childIndex));
        }
        else if (confirmation[datum[keyField]]) {
            const confirmationHelper = confirmation[datum[keyField]];
            return (_jsxs("td", { style: { textAlign: "right" }, children: [_jsx(Button, { variant: "danger", size: "sm", className: "kpactions confirmation", onClick: async (e) => {
                            e.stopPropagation();
                            await onHandleAction(confirmationHelper);
                        }, children: _jsx(Translate, { value: "kptable.confirm.yes" }) }), "\u00A0", _jsx(Button, { size: "sm", className: "kpactions confirmation", onClick: async (e) => {
                            e.stopPropagation();
                            await onCancelAction(confirmationHelper);
                        }, children: _jsx(Translate, { value: "kptable.confirm.no" }) })] }, childIndex));
        }
        else {
            if (!collapsed) {
                return (_jsxs("td", { style: { textAlign: "right" }, children: [_jsx("span", {}), actions
                            .filter((action) => !action.shouldRender || action.shouldRender(datum))
                            .map((action, actionIndex) => (_jsx(TableAction, { id: id, action: action, index: actionIndex, datum: datum, keyField: keyField, collapsed: collapsed, disabled: ld.isFunction(action.disabled) ? action.disabled(datum) : action.disabled }, actionIndex)))] }, childIndex));
            }
            else {
                return (_jsxs("td", { style: { textAlign: "right" }, children: [actions
                            .filter((action) => (!action.shouldRender || action.shouldRender(datum)) && !def(action.collapsable, true))
                            .map((action, actionIndex) => (_jsx(TableAction, { id: id, action: action, index: actionIndex, datum: datum, keyField: keyField, collapsed: collapsed, disabled: ld.isFunction(action.disabled) ? action.disabled(datum) : action.disabled }, actionIndex))), _jsxs(Dropdown, { align: "end", className: "kpactions-parent", onClick: (event) => event.stopPropagation(), children: [tooltipate(_jsx(Dropdown.Toggle, { id: `actions-${id}-${datum[keyField]}`, className: "kpactions kpborderless kpcollapsed", children: _jsx("i", { className: "far fa-ellipsis-v fag" }) }), _jsx(Translate, { value: "kptable.actions" })), _jsx(Dropdown.Menu, { children: actions
                                        .filter((action) => (!action.shouldRender || action.shouldRender(datum)) && def(action.collapsable, true))
                                        .map((action, actionIndex) => (_jsx(TableAction, { id: id, action: action, index: actionIndex, datum: datum, keyField: keyField, collapsed: collapsed, disabled: ld.isFunction(action.disabled) ? action.disabled(datum) : action.disabled }, actionIndex))) })] })] }, childIndex));
            }
        }
    }
}
export const TableBody = ({ id, children, checkboxes, data, keyField, checked, onChangeCheck, confirmation, waiting, onHandleAction, onCancelAction, columnVisibility, variableColumns, rowAction, }) => {
    return (_jsx("tbody", { children: data.map((datum, index) => (_jsxs("tr", { className: rowAction ? "hooverable" : "", onClick: async () => {
                if (rowAction) {
                    await rowAction(datum);
                }
            }, children: [checkboxes ? (_jsx("td", { onClick: (e) => {
                        e.stopPropagation();
                    }, children: _jsx(KCheck, { id: `check-${index}`, label: "", type: "checkbox", checked: !!checked[datum[keyField]], onChange: () => {
                            onChangeCheck(id, datum[keyField], !checked[datum[keyField]]);
                        } }) })) : null, React.Children.map(children, (child, childIndex) => {
                    const { type, colid, hideable = true } = child.props;
                    return (columnVisibility[colid] || !hideable) && type !== ColumnType.ACTIONS
                        ? renderCell(id, child, childIndex, datum, keyField, confirmation, waiting, onHandleAction, onCancelAction)
                        : null;
                }), variableColumns
                    ? variableColumns.columns.map((column, childIndex) => (columnVisibility[column] ? _jsx("td", { children: variableColumns.render(datum, column) }, childIndex) : null))
                    : null, React.Children.map(children, (child, childIndex) => {
                    const { type } = child.props;
                    return type === ColumnType.ACTIONS ? renderCell(id, child, childIndex, datum, keyField, confirmation, waiting, onHandleAction, onCancelAction) : null;
                })] }, index))) }));
};
